export function formatPrice(value) {
  if (Number(value) === 0) {
    return 'FREE'
  }
  
  const val = (value / 1).toFixed().replace('.', ',')
  return 'Rp ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.')
}